import { useCallback } from 'react';
import { updateRecurringTaskDetails } from '../../services/taskServices';
import { DropdownItem } from '../dropdown';
import { Submenu } from './styles';
import { rootStore } from '../../mobx/rootStore';
import { TaskModel } from '../../mobx/models/task';

const daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);

interface Props {
  data?: TaskModel;
  loadData?: () => void;
}
export default function SubMenuMonthly(props: Props) {
  //mobx store
  const { taskStore } = rootStore;
  const { createTaskInput } = taskStore;

  const setMonthlyRecurringTask = useCallback(
    async (day: string) => {
      try {
        const payloadTask = {
          projectId: props?.data?.projectId,
          start: day.toLowerCase(),
          recurringInterval: 'monthly'
        };
        const response = await updateRecurringTaskDetails(props?.data?.id, payloadTask);
        if (response && props?.loadData) {
          props.loadData();
        }
        rootStore.taskStore.createTaskInput.setStart(day);
        rootStore.taskStore.createTaskInput.setRecurringInterval('monthly');
      } catch (error) {
        console.log('error', error);
      }
    },
    [props]
  );
  return (
    <Submenu>
      {daysInMonth.map((day) => (
        <DropdownItem
          key={day}
          isSelected={createTaskInput?.start === day.toString()}
          onClick={() => setMonthlyRecurringTask(day.toString())}>
          {day}
        </DropdownItem>
      ))}
    </Submenu>
  );
}
